<template>
    <div class="w-full md:w-auto">
        <a
            class="btn text-sm is-danger w-full"
            href="#"
            @click="$modal.show('delete-project')"
        >
            Radera
        </a>
        <adaptive-form-modal
            name="delete-project"
            primary-button-text="Radera"
            primary-button-class="is-danger"
            title="Radera projekt"
            :redirect-to="redirectRoute"
            method="delete"
            :action="actionRoute"
        >
            <p>Vill du verkligen radera {{ project.name }}?</p>
            <p>
                <strong>
                    Detta kommer att radera hela projektet och alla dess adresser.
                </strong>
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        computed: {
            actionRoute() {
                return route('api.sales-projects.destroy', this.project);
            },
            redirectRoute() {
                return route('admin.sales-projects.index');
            },
        },
    };
</script>
